import SecondarySlideDurationView from './SecondarySlideDurationView';

export default SecondarySlideDurationView;
